import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  caricamentoInCorso: false,
  tickets: [],
  showModaleNuovoTicket: false,
  testoNuovoTicket: '',
};

const ticketsSlice = createSlice({
  name: 'tickets',
  initialState,
  reducers: {
    caricamento(state, action) {
      state.caricamentoInCorso = Boolean(action.payload);
    },
    aggiornaTickets(state, action) {
      state.tickets = action.payload;
    },
    mostraModaleNuovoTicket(state) {
      state.showModaleNuovoTicket = true;
    },
    nascondiModaleNuovoTicket(state) {
      state.testoNuovoTicket = '';
      state.showModaleNuovoTicket = false;
    },
    setTestoNuovoTicket(state, action) {
      state.testoNuovoTicket = action.payload;
    },
  },
});

export const { caricamento, aggiornaTickets, mostraModaleNuovoTicket, nascondiModaleNuovoTicket, setTestoNuovoTicket } = ticketsSlice.actions;
const ticketsReducer = ticketsSlice.reducer;

export default ticketsReducer;
